import { DefaultButton, IButtonProps } from "@fluentui/react";

export const SecondaryButton: React.FC<IButtonProps> = (props) => {
    return <DefaultButton {...props} styles={{ ...props.styles}}  />
}